"use client";

import React, { FC, PropsWithChildren } from "react";
import {
  GlobalStateProvider,
  ShaApplicationProvider,
  AttachmentsEditorProvider,
  useNextRouter,
} from "@shesha-io/reactjs";
import { EnterpriseApplicationPlugin } from "@shesha-io/enterprise";
import { AppProgressBar } from "next-nprogress-bar";
import { useTheme } from "antd-style";

export interface IAppProviderProps {
  backendUrl: string;
}

export const AppProvider: FC<PropsWithChildren<IAppProviderProps>> = ({
  children,
  backendUrl,
}) => {
  const nextRouter = useNextRouter();
  const theme = useTheme();

  const noAuth = Boolean(nextRouter.path?.includes("/no-auth"));

  return (
    <GlobalStateProvider>
      <AppProgressBar height="4px" color={theme.colorPrimary} shallowRouting />
      <ShaApplicationProvider
        backendUrl={backendUrl}
        router={nextRouter}
        noAuth={noAuth}
      >
        <EnterpriseApplicationPlugin>
          {/* 0.46.0 renamed StoredFilesProvider; the backend url now comes from app context. */}
          <AttachmentsEditorProvider ownerId={""} ownerType={""}>
            {children}
          </AttachmentsEditorProvider>
        </EnterpriseApplicationPlugin>
      </ShaApplicationProvider>
    </GlobalStateProvider>
  );
};
